<template>
  <div class="spacer"></div>
</template>

<style lang="scss" scoped>
.spacer {
  flex-grow: 1;
}
</style>
